import * as React from 'react';
import { AbstractReactFactory } from '@projectstorm/react-canvas-core';

import NodeWidget from '../nodeWidget/NodeWidget';
import { NodeModelTypeEnum } from '../enums';
import { ValveNodeModel } from './ValveNodeModel';
import { ValveNodeWidget } from './ValveNodeWidget';

export class ValveNodeFactory extends AbstractReactFactory {
  constructor(private isMainMap) {
    super(NodeModelTypeEnum.Valve);
    this.isMainMap = isMainMap;
  }

  generateModel() {
    return new ValveNodeModel();
  }

  nodeUI(event) {
    return <ValveNodeWidget engine={this.engine} node={event.model} width={44} height={44} shouldShowTooltip={true} />;
  }

  generateReactWidget(event) {
    return this.isMainMap ? (
      <NodeWidget entity={event.model.getEntity()} onDevices={event.model.getOnDevices()}>
        {this.nodeUI(event)}
      </NodeWidget>
    ) : (
      this.nodeUI(event)
    );
  }
}
